export default {
    widgetEnable: 'Widget Enable',
    signInText: 'Log in to your Account',
    password: 'Password',
    passwordBNI: 'Password',
    login: 'Login',
    loginTooltip1: 'enter username',
    loginTooltip2: 'enter password',
    forgotPassword: 'Forgot password',
    registerNow: 'Register',
    registerHere: 'Register',
    dontHaveAccount: 'Dont have Account ? ',
    loginText: 'Welcome to ASYX X4',
    taskManagement: 'Task Management',
    search: 'Search',
    reset: 'Reset',
    businessKey: 'Business Key',
    name: 'Name',
    companyName: 'Company Name',
    downPaymentGreater: 'Down payment can not exceed total order amount',
    clientName: 'Client Name',
    created: 'Created',
    action: 'Action',
    actions: 'Actions',
    taskDetail: 'Task Detail',
    key: 'Key',
    settlementDetail: 'Settlement Detail',
    value: 'Value',
    accept: 'Accept',
    approve: 'Approve',
    reject: 'Reject',
    complete: 'Complete',
    amend: 'Amend',
    edit: 'Edit',
    revise: 'Revise',
    normalPayment: 'Normal Payment',
    documentDetail: 'Document Detail',
    documentType: 'Document Type',
    specificReference: 'Specific Reference',
    specificDocumentStatus: 'Specific Document Status',
    amountRange: 'Amount Range',
    periodRange: 'Period Range',
    transactionFilter: 'Transaction Filter',
    dateRange: 'Date Range',
    advanceSearch: 'Advanced',
    documentStatus: 'Document Status',
    period: 'Period',
    amount: 'Amount',
    amountMinimum: 'Amount Minimum',
    amountMaximum: 'Amount Maximum',
    documentReference: 'Document Reference',
    reference: 'Reference',
    seller: 'Seller',
    buyer: 'Buyer',
    status: 'Status',
    dueDate: 'Due Date',
    currency: 'Currency',
    type: 'Type',
    received: 'Received',
    dateReceived: 'Date Received',
    accountDetail: 'Account Detail',
    disbursementDetails: 'Disbursement Details',
    disbursementTransferDate: 'Disbursement Transfer Date',
    settlementTransferDate: 'Settlement Transfer Date',
    paymentDate: 'Transfer Date',
    maturityDate: 'Maturity Date',
    totalAmountDoc: 'Total amount of documents',
    totalNumber: 'Total number of results',
    userManagement: 'User Management',
    bankManagement: 'Bank Management',
    bankInformation: 'Add Bank Information',
    localBankCode: 'Local Bank Code',
    branchCode: 'Branch Code',
    postCode: 'Post Code',
    'bankName.isEmpty': 'Bank Name is required',
    bankInformationisAlreadyExist: 'The bank information is already exists',
    bankInformationHasBeenCreated: 'The bank information has been created',
    deleteMessage: 'Are you sure want to delete this data',
    bulkMessage: 'Are you sure want to',
    followData: 'the following data ?',
    add: 'Add',
    addReferenceRate: 'Add Reference Rate',
    addCommissionSetting: 'Add Commission Setting',
    userName: 'Username',
    userNameBNI: 'Username',
    view: 'View',
    delete: 'Delete',
    cancel: 'Cancel',
    deletePranota: 'Delete Pra Nota',
    provideValidationMessages: '* Please provide a valid information',
    provideValidSettlementAmount: '* The value cannot be more than Outstanding',
    validationRegistrationNumber: `* Please fill in with 0 number if you don't have registration number`,
    validationUsernameMessages: '* Please enter your username',
    validationPasswordMessages: '* Please enter your password',
    validationUpdatePasswordMessage:
        '* Please include number, capital, low case, symbol at least 9 character.',
    save: 'Save',
    userDetail: 'User Detail',
    username: 'Username',
    firstName: 'First Name',
    middleName: 'Middle Name',
    lastName: 'Last Name',
    email: 'Email',
    lastLoginTime: 'Last Login Time',
    account: 'Account',
    emailAddress: 'Email Address',
    emailNotification: 'Email Notification',
    mobileNumber: 'Mobile Number',
    smsNotification: 'SMS Notification',
    city: 'City',
    country: 'Country',
    languageISOCode: 'Language ISO Code',
    postalCode: 'Postal Code',
    address: 'Address',
    jobTitle: 'Job Title',
    personTitle: 'Prefix',
    idType: 'ID Type',
    idNumber: 'ID Number',
    otp: 'One Time Password (OTP)',
    settings: 'Settings',
    pph23Flagging: 'PPh 23',
    upfrontBilling: 'Upfront Billing',
    deleteUserLDAP: 'Delete User LDAP',
    createUserLDAP: 'Create User LDAP',
    resetPassword: 'Reset Password',
    option: 'Option',
    organizationManagement: 'Organization Management',
    recalculate: 'Recalculate',
    organizationDetail: 'Organization Detail',
    fullName: 'Full Name',
    timezone: 'Timezone',
    contactPerson: 'Contact Person',
    contactPersonDepartment: 'Contact Person Department',
    contactPersonPhone: 'Contact Person Phone',
    contactPersonEmail: 'Contact Person Email',
    industry: 'Industry',
    subIndustry: 'Sub Industry',
    billingAccountName: 'Billing Account Name',
    billingAccountNumber: 'Billing Account Number',
    billingTaxable: 'Billing Taxable',
    calendar: 'Calendar',
    authorization: 'Authorization',
    organizationCalendar: 'Organization Calendar',
    organizationCalendarDetail: 'Organization Calendar Detail',
    exclusions: 'Exclusions',
    addExclusions: 'Add Exclusions',
    date: 'Date',
    description: 'Description',
    organizationAuthorization: 'Organization Authorization',
    organization: 'Organization',
    organizations: 'Organizations',
    role: 'Role',
    user: 'User',
    authorizationDetail: 'Authorization Detail',
    authorizationDetailForm: 'Authorization Detail Form',
    roleManagement: 'Role Management',
    roleDetail: 'Role Detail',
    rolePermission: 'Role Permission',
    roleAssign: 'Role Assign',
    programManagement: 'Program Management',
    programDetail: 'Program Detail',
    supportedCurrencies: 'Supported Currencies',
    funderEnable: 'Enable Funder',
    funderMultiple: 'Multiple Funder',
    funderConfigurations: 'Funder Configurations',
    buyerEnable: 'Enable Buyer',
    buyerMultiple: 'Multiple Buyer',
    relation: 'Relation',
    registeredDate: 'Registered Date',
    creditType: 'Credit Type',
    buyerConfigurations: 'Buyer Configurations',
    sellerEnable: 'Enable Seller',
    sellerMultiple: 'Multiple Seller',
    sellerConfigurations: 'Seller Configurations',
    pleaseSelect: 'Please select...',
    contractManagement: 'Contract Management',
    contractDetail: 'Contract Detail',
    contractName: 'Contract Name',
    contractAdd: 'Add Contract',
    contractEdit: 'Edit Contract',
    assignProgram: 'Assign Program',
    deactivatedContract: 'Deactivate Contract',
    organizationName: 'Organization Name',
    buyerOrganizations: 'Buyer Organizations',
    sellerOrganizations: 'Seller Organizations',
    funderOrganizations: 'Funder Organizations',
    uploadQuotes: 'Upload Quotes',
    upload: 'Upload',
    buyerName: 'Buyer Name',
    supplierCode: 'Supplier Code',
    supplierName: 'Supplier Name',
    sellerName: 'Seller Name',
    areaCode: 'Area Code',
    salesCode: 'Sales Code',
    quoteNumber: 'Quote Number',
    paymentTerm: 'Payment Term',
    warehouseCode: 'Warehouse Code',
    deliveryFrom: 'Delivery From',
    deliveryTo: 'Delivery To',
    creationDate: 'Creation Date',
    tags: 'Status',
    expectedDeliveryDate: 'Expected Delivery Date',
    addLineItem: 'Add Line Item',
    code: 'Code',
    uom: 'UOM',
    price: 'Price',
    qty: 'Quantity',
    vat: 'VAT',
    discount: 'Discount',
    submit: 'Submit',
    createQuote: 'Create Quote',
    createInvoice: 'Create Invoice',
    createShippingLetter: 'Create Shipping Letter',
    senderName: 'Sender Name',
    receiverName: 'Receiver Name',
    deliveryDate: 'Delivery Date',
    expiryDate: 'Expiry Date',
    lineItems: 'Line Items',
    itemCode: 'Item Code',
    no: 'No.',
    documentView: 'Document View',
    despatchAdvice: 'Despatch Advice',
    despatchAdviceInventoryChecking: 'Inventory Checking',
    tracingNumber: 'Tracing Number',
    buyerCode: 'Buyer Code',
    buyerFullName: 'Buyer Full Name',
    buyerContact: 'Buyer Contact',
    sellerCode: 'Seller Code',
    sellerFullName: 'Seller Full Name',
    sellerContact: 'Seller Contact',
    sellerConfiguration: 'Seller Configuration',
    orderReference: 'Order Reference',
    orderDate: 'Order Date',
    receiveDate: 'Receive Date',
    despatchedQuantity: 'Despatched Quantity',
    receivedQuantity: 'Received Quantity',
    serviceLevel: 'Service Level',
    referenceSourceManagement: 'Reference Source Management',
    ReferenceSourceAdd: 'Reference Source Add',
    referenceSourceDetail: 'Reference Source Detail',
    referenceSourceEdit: 'Reference Source Edit',
    invoice: 'Invoice',
    buyerNPWP: 'Buyer Registration Number',
    sellerNPWP: 'Seller Registration Number',
    despatchAdviceReference: 'Despatch Advice Reference',
    receivingAdviceReference: 'Receiving Advice Reference',
    receivingAdviceDate: 'Receiving Advice Date',
    invoiceReference: 'Invoice Reference',
    taxSerialNumber: 'Tax Serial Number',
    vatAmount: 'VAT Amount',
    totalAmount: 'Total Amount',
    order: 'Order',
    billingStatement: 'Billing Statement',
    quote: 'Quote',
    receivingAdvice: 'Receiving Advice',
    despacthAdviceReference: 'Despatch Advice Reference',
    organizationSales: 'Organization Sales',
    area: 'Area',
    salesDetail: 'Sales Detail',
    oneTimePassword: 'One Time Password',
    pleaseEnterYourReceiveCode: 'Please Enter Your Receive Code',
    enterReceiveCode: 'Enter Receive Code',
    enableOTP: 'Enable OTP',
    sendCode: 'Send Code',
    indonesian: 'Indonesian',
    english: 'English',
    uzbekistan: 'Uzbekistan',
    russian: 'Russian',
    vietnam: 'Vietnam',
    roleSelection: 'Role Selection',
    userSelection: 'User Selection',
    taskName: 'Task Name',
    shippingLetter: 'Shipping Letter',
    senderContact: 'Sender Contact',
    street: 'Street',
    restrictions: 'Restrictions',
    senderTelephone: 'Sender Telephone',
    warehouse: 'Warehouse',
    shippingNumber: 'Shipping Number',
    shippingDate: 'Shipping Date',
    receiverContact: 'Receiver Contact',
    receiverTelephone: 'Receiver Telephone',
    totalColie: 'Total Colie',
    uploadAttachment: 'Upload Attachment',
    register: 'Register',
    registerText: 'Create your account',
    createAccount: 'Create Account',
    quoteReference: 'Quote Reference',
    quoteCurrency: 'Quote Currency',
    quoteDate: 'Quote Date',
    orderCurrency: 'Order Currency',
    fileName: 'File Name',
    requestQuantity: 'Request Quantity',
    invoiceDate: 'Invoice Date',
    sender: 'Sender',
    organizationParent: 'Organization Parent',
    grandTotal: 'Grand Total',
    parentCompany: 'Parent Company',
    documentTypeStatus: 'Type & Document Status',
    assetTypeStatus: 'Asset Type & Status',
    lineItemRevision: 'Line Item Revision',
    assetStatus: 'Asset Status',
    backToLoginPage: 'Back to login page',
    virtualAccountNumber: 'Virtual Account Number',
    remark: 'Remark',
    printPdf: 'Print Pdf',
    registrationNumber: 'Registration Number',
    details: 'Details',
    configProperty: 'Property',
    configValue: 'Value',
    accountType: 'Account Type',
    accountNumber: 'Account Number',
    showRelativeTime: 'Show Relative Time',
    showDocumentRead: 'Show Document Read Status',
    funderRequiredAccountTypes: 'Funder Account Type',
    buyerRequiredAccountTypes: 'Buyer Account Type',
    sellerRequiredAccountTypes: 'Seller Account Type',
    financialRequest: 'Financial Request',
    paymentId: 'Payment ID',
    financingTenor: 'Financing Tenor',
    calculationStartDate: 'Calculation Start Date',
    maximumFinancingTenor: 'Maximum Financing Tenor',
    interestRate: 'Interest Rate',
    commissionAmount: 'Commission Amount',
    total: 'Total',
    financialInformation: 'Financial Information',
    whtinterstRate: 'WHT interest Rate',
    interestAmount: 'Interest Amount',
    requestDate: 'Request Date',
    customerType: 'Customer Type',
    about: 'About',
    interestIndex: 'Interest Index',
    contactUs: 'Contact Us',
    download: 'Download',
    uploadAccurate: 'Upload Accurate',
    sales: 'Sales',
    approvalMatrix: 'Approval Matrix',
    approvalMatrixList: 'Approval Matrix List',
    approvalMatrixDetail: 'Approval Matrix Detail',
    productMaintenance: 'Product Maintenance',
    itemDescription: 'Item Description',
    size: 'Size',
    priceList: 'Price List',
    priceTier: 'Price Tier',
    productDetail: 'Product Detail',
    productCreate: 'Create Product',
    addPrice: 'Add Price',
    stockValidation:
        'Cannot proceed quote transaction, please restock your warehouse before continuing',
    failedValidation: 'Failed to Processing Task',
    levelType: 'Level Type',
    dateCreated: 'Creation Date',
    maximumCreditLine: 'Maximum Credit Line',
    outstandingCredit: 'Outstanding Credit',
    availableCreditLimit: 'Available Credit Limit',
    funderName: 'Funder Name',
    maximumTenor: 'Maximum Tenor',
    financingPercentage: 'Financing Percentage',
    invoiceAmount: 'Invoice Amount',
    invoiceDiscount: 'Invoice Discount',
    interestCost: 'Interest Cost',
    fundedAmount: 'Funded Amount',
    currentTenor: 'Current Tenor',
    assets: 'Assets',
    asset: 'Asset',
    assetType: 'Asset Type',
    assetAmount: 'Asset Amount',
    originalAmount: 'Original Amount',
    funder: 'Funder',
    createNew: 'Create New',
    addLevel: 'Add Level',
    addGroup: 'Add Group',
    groupName: 'Group Name',
    revisedDate: 'Revised Date',
    addUser: 'Add Approver',
    approverList: 'Approver List',
    revisedMessage: 'Are you sure want to revise this document',
    minimumApprover: 'Minimum Approver',
    fundingRequest: 'Financing Statement',
    expectedDisbursementDate: 'Expected Disbursement Date',
    expectedSettlementDate: 'Expected Settlement Date',
    requestedCredit: 'Requested Credit',
    totalLimit: 'Total Limit',
    vehicleNumber: 'Vehicle Number',
    downPaymentReference: 'Down Payment Reference',
    totalOutstanding: 'Total Outstanding',
    totalLimitUtilization: 'Total Limit Utilization',
    referenceRate: 'Reference Rate',
    rateChange: 'Rate Change',
    rateChangeLockStatus: 'Rate Change Lock Status',
    suspension: 'Suspension',
    commissionRate: 'Commission Rate',
    spread: 'Spread',
    interestCalculationMethod: 'Interest Calculation Method',
    brokerFee: 'Broker Fee',
    othersFee: 'Others Fee',
    technologyFee: 'Technology Fee',
    insuredPercentage: 'Insured Percentage',
    insuredAmount: 'Insured Amount',
    creditInsurer: 'Credit Insurer',
    stage: 'Stage',
    disbursementDate: 'Disbursement Request Date',
    eligibleAmount: 'Eligible Amount',
    disbursementAmount: 'Disbursement Amount',
    discountFee: 'Discount Fee',
    arrearsFee: 'Arrears Fee',
    lateFee: 'Late Fee',
    payment: 'Payment',
    feeType: 'Fee Type',
    calculationMethod: 'Calculation Method',
    calculationRate: 'Calculation Rate',
    calculationResult: 'Calculation Result',
    arrears: 'Arrears',
    transfer: 'Transfer',
    settlementDate: 'Settlement Date',
    transferDate: 'Transfer Date',
    actualDisbursementDate: 'Actual Disbursement Date',
    fromAccount: 'From Account',
    fromAccountNumber: 'From Account Number',
    soapResponse: 'Response',
    soapNarative: 'Narative',
    toAccount: 'To Account',
    toAccountNumber: 'To Account Number',
    amountType: 'Amount Type',
    feeDetail: 'Fee Detail',
    rateChangesHistory: 'Rate Change History',
    feeInformation: 'Fee Information',
    chargeDetail: 'Charge Details',
    disbursement: 'Disbursement',
    settlement: 'Settlement',
    programName: 'Program Name',
    programDescription: 'Program Description',
    stageConfigurations: 'Stage Configurations',
    stageNumber: 'Stage Number',
    requiredAccountTypes: 'Account Types',
    insurance: 'Insurance',
    organizationCode: 'Organization Code',
    funderSelection: 'Co-Funding',
    funderProperty: 'Funder Property',
    buyerProperty: 'Buyer Property',
    sellerProperty: 'Seller Property',
    dailyCharge: 'Daily Charges',
    requestStatement: 'Request Statement',
    dateUpdated: 'Date Updated',
    financialRequestReference: 'Financial Request Reference',
    documentChecking: 'Document Checking',
    close: 'Close',
    disbursementHistory: 'Disbursement History',
    settlementHistory: 'Settlement History',
    totalDailyCharges: 'Total Daily Charges',
    totalTenor: 'Total Tenor',
    disburseAmountValidation: '* Amount must be equal to eligible amount',
    assetDate: 'Asset Date',
    assetDetail: 'Asset Detail',
    notifications: 'Notifications',
    notificationSettings: 'Notification Settings',
    loadMore: 'Load More!',
    repaymentAmount: 'Repayment Amount',
    remainingAmount: 'Remaining Amount',
    outstandingAmount: 'Outstanding Amount',
    residual: 'Residual',
    residualTransferDate: 'Residual Transfer Date',
    settlementBookingDate: 'Settlement Booking Date',
    actualSettlementDate: 'Actual Settlement Date',
    processedDocument: 'Financing Statement',
    settlementAmount: 'Settlement Amount',
    loginContactUs: 'Need assistance? Contact us!',
    assetCreationDate: 'Asset Creation Date',
    percentage: 'Percentage',
    automatic: 'Automatic',
    suspend: 'Suspend',
    noConfigurations: 'No Configurations Added.',
    financialOrganization: 'Financial Organization',
    addFinancialOrganization: 'Add Financial Organization',
    editFinancialOrganization: 'Edit Financial Organization',
    accountName: 'Account Name',
    bankCode: 'Bank Code',
    branch: 'Branch',
    branchName: 'Branch Name',
    bankName: 'Bank Name',
    bankAddress: 'Bank Address',
    swiftCode: 'SWIFT Code',
    bankDetails: 'Bank Details',
    addNew: 'Add New',
    approvalConfirm: 'Please confirm the approval',
    whtInterest: 'WHT Interest',
    whtInterestAmount: 'WHT Interest Amount',
    whtProcessingFee: 'WHT Processing Fee',
    whtProcessingFeeAmount: 'WHT Processing Fee Amount',
    processingFee: 'Processing Fee',
    totalDisbursementAmount: 'Total Disbursement Amount',
    rate: 'Rate',
    rating: 'Rate',
    leaveComment: 'Leave a comment',
    method: 'Method',
    errorRating: 'Rate Should Be Selected.',
    interest: 'Interest',
    arrears_on_settlement: 'Arrears on Settlement',
    bankCharge: 'Bank Charge',
    methods: 'Methods',
    disbursementMode: 'Disbursement Mode',
    cost: 'Cost',
    forms: 'Forms',
    maximumAmount: 'Maximum Amount',
    property: 'Property',
    totalCharge: 'Total Charge',
    extensionSetting: 'Extension Setting',
    penaltyEnabled: 'Penalty Enabled',
    extensionInterest: 'Extension Interest',
    penaltyGracePeriod: 'Penalty Grace Period',
    cycle: 'Penalty Cycle',
    penaltyInterest: 'Penalty Interest',
    freeze: 'Freeze',
    days: 'Days',
    interestOnPenalty: 'Interest On Penalty',
    arrearsFeeAfterDueDate: 'Arrears Fee After Due Date',
    dailyChecking: 'Daily Checking',
    addPenaltyInterest: 'Add',
    penalty: 'Penalty',
    addPenalty: 'Add Penalty',
    extend: 'Extend',
    maximumExtendedTenor: 'Maximum Extended Tenor',
    extensionDate: 'Extension Date',
    limitContractSetting: 'Limit Contract Setting',
    maximumCreditLimit: 'Maximum Credit Limit',
    overridePercentage: 'Override Percentage',
    assetPercentage: 'Asset Percentage',
    fundingPercentage: 'Funding Percentage',
    activationSetting: 'Activation Setting',
    overrideAmount: 'Override Amount',
    enabled: 'Enabled',
    litigation: 'Litigation',
    proformaInvoice: 'Proforma Invoice',
    flowConfigurations: 'Flow Configurations',
    programType: 'Program Type',
    flowPreview: 'Flow Preview',
    propertySetting: 'Property Setting',
    inventoryChecking: 'Inventory Checking',
    partlyDespatchAdvice: 'Partly Despatch Advice',
    uploadInvoices: 'Upload Invoices',
    uploadInventory: 'Upload Inventory',
    uploadProduct: 'Upload Product',
    shippingInformation: 'Shipping Information',
    participantInformation: 'Participant Information',
    otherInformation: 'Other Information',
    incoTerm: 'Incoterms',
    bniDirect: 'BNI Direct',
    product: 'Product',
    vesselId: 'Vessel ID',
    billOfLadingDate: 'Shipping Date',
    createOrder: 'Create Order',
    standardPercentage: 'Water Quality',
    item: 'Item',
    balanceStock: 'Balance Stock',
    valueUpdate: 'Value Update',
    updateStock: 'Update Stock',
    invoiceCurrency: 'Invoice Currency',
    invoiceNumber: 'Invoice Number',
    incoterm: 'Incoterm',
    invoiceLineItem: 'Invoice Line Item',
    loadPort: 'Load Port',
    dischargePort: 'Discharge Port',
    daysDivisorTitle: 'Number of Days Divisor',
    divisor: 'Divisor',
    uploadOrder: 'Upload Order',
    noAction: 'No Action',
    despatchGoodsConfirmation: 'Despatch Goods Confirmation',
    despatchAdviceDate: 'Despatch Advice Date',
    proformaInvoiceReference: 'Proforma Invoice Reference',
    proformaInvoiceDate: 'Proforma Invoice Date',
    buyerContactPhone: 'Buyer Contact Phone',
    sellerContactPhone: 'Seller Contact Phone',
    buyerAccountNumber: 'Buyer Account Number',
    sellerAccountNumber: 'Seller Account Number',
    actualWaterContent: 'Actual Water Content',
    waterContentReduction: 'Rafaction',
    proposalRejectionDays: 'Proposal Rejection Days',
    cutOffTime: 'Cut Off Time (HH:MM:SS)',
    minimumFinancingTenor: 'Minimum Financing Tenor',
    maximumPassDueDate: 'Maximum Pass Due Date',
    buyerRecourse: 'Buyer Recourse',
    buyerSetting: 'Buyer Setting',
    sellerRecourse: 'Seller Recourse',
    sellerSetting: 'Seller Setting',
    residuals: 'Residuals',
    assetSettlement: 'Asset Settlement',
    repaymentDate: 'Repayment Date',
    dilutions: 'Dilutions',
    manualSettlement: 'Manual Settlement',
    assetNumber: 'Asset Number',
    settle: 'Settle',
    dilution: 'Dilution',
    remarks: 'Remarks',
    generalLedger: 'General Ledger',
    invoicePurchased: 'Invoice Purchased',
    documentList: 'Document List',
    accountPayable: 'Account Payable',
    disbursementTransferApproval: 'Disbursement Transfer Approval',
    settlementTransferApproval: 'Settlement Transfer Approval',
    bankGlNumber: 'Bank Gl Number',
    sdReceipt: 'Sd Receipt',
    interestIncome: 'Interest Income',
    penaltyInterestIncome: 'Penalty Interest Income',
    processingFeeIncome: 'Processing Fee Income',
    bankCharges: 'Bank Charges',
    accountReceivables: 'Account Receivables',
    vatCode: 'Vat Code',
    disbursementApproval: 'Disbursement Approval',
    attachmentList: 'Attachment List',
    lineItemNoData: 'No Data Found.',
    loading: 'Processing...',
    start: 'Start',
    prepaidAmount: 'Prepaid Amount',
    downPayment: 'Down Payment',
    scheduler: 'Scheduler',
    fscm: 'Financial Supply Chain Management',
    pleaseSignIn: 'Please Sign In',
    convergenceTag1: 'Providing innovative funding solutions,',
    convergenceTag2: 'so you can focus on growing your business.',
    taskEditDocumentMessage: 'Document successfully edited.',
    rejectionRemark: 'Rejection Remark',
    priceCorrection: 'Price Correction',
    overdueDays: 'Overdue Days',
    creditRating: 'Credit Rating',
    allowFinance: 'Allow To Finance',
    fromInvoice: 'From Invoice',
    invoiceRecalculate: '* Amount will be recalculated after document has been saved.',
    qualityAnalysisResult: 'Quality Analysis Result',
    testQuality: 'Rice Maturity Test Results',
    standardText: 'Standard',
    notStandardText: 'Not Accordingly Standard',
    clearSelection: 'Clear Selection',
    receivedQuantityChecking: 'Received Quantity Checking',
    discountApproval: 'Discount Approval',
    serviceProviderApproval: 'Service Provider Approval',
    relatedAttachmentList: 'Related Attachment List',
    bookingOffice: 'Booking Office',
    jobManagement: 'Job Management',
    JobScheduler: 'Job Scheduler',
    JobSchedulerTrigger: 'Job Scheduler Trigger',
    JobExecutionDetails: 'Job Execution Details',
    jobName: 'Job Name',
    lastRunTime: 'Last Run Time',
    nextRunTime: 'Next Run Time',
    lastResult: 'Last Result',
    approval: 'Approval',
    JobSchedulers: 'Job Schedulers',
    JobExecutions: 'Job Executions',
    jobInstances: 'Job Instances',
    calendarName: 'Calendar Name',
    cronExpression: 'Cron Expression',
    activeContract: 'Active Contract',
    jobActiveEntity: 'Job Active Entity',
    jobPerspective: 'Job Perspective',
    state: 'State',
    addTrigger: 'Add Trigger',
    enable: 'Enable',
    disable: 'Disable',
    referenceSource: 'Reference Source Enabled',
    reindexDocument: 'Reindex Document',
    documentUuid: "Document's UUID",
    'com.asyx.x4.document.asset.already_have_fs': 'The Invoice has formed a Financing Statement',
    'com.asyx.x4.finprocess.settlement.invalid-settlement-amount':
        '"Settlement Amount" should not greater than the "Outstanding Amount"',
    'com.asyx.x4.user.nofill': 'Please fill out the information',
    'com.asyx.x4.user.onlyAlphanumeric_username': 'The username is invalid',
    'com.asyx.x4.user.maximumCharacter_username': 'The username is invalid',
    'com.asyx.x4.user.onlyAlphabetic_name': 'The name is invalid',
    'com.asyx.x4.user.manimumCharacter_name': 'The name is invalid',
    'com.asyx.x4.user.invalidFormat_email': 'The email address is invalid',
    'com.asyx.x4.user.maximumCharacter_email': 'The email address is invalid',
    'com.asyx.x4.user.onlyNumeric_mobileNumber': 'The mobile number is invalid',
    'com.asyx.x4.user.minimumCharacter_mobileNumber': 'The mobile number is invalid',
    'com.asyx.x4.user.weak_password': 'The password is invalid',
    'com.asyx.x4.user.nofill_username': 'Please fill out the username',
    'com.asyx.x4.user.nofill_name': 'Please fill out the name',
    'com.asyx.x4.user.nofill_email': 'Please fill out the email address',
    'com.asyx.x4.user.nofill_mobileNumber': 'Please fill out the mobile number',
    'com.asyx.x4.user.nofill_password': 'Please fill out the password',
    'com.asyx.x4.date.nofill': 'Please select the date',
    'com.asyx.x4.calandar.nofill_name': 'Please fill out the name',
    'com.asyx.x4.authorization.user-role_nofill': 'Please select the user account and the role',
    'com.asyx.x4.authorization.role_nofill': 'Please select the role',
    'com.asyx.x4.authorization.user_nofill': 'Please select the user account',
    'com.asyx.x4.organization.nofill_reference': 'Reference should contain a value',
    'com.asyx.x4.organization.onlyAlphanumeric_reference': 'The reference is invalid',
    'com.asyx.x4.organization.max_reference': 'The reference is invalid',
    'com.asyx.x4.organization.nofill_fullname': 'Full Name should contain a value',
    'com.asyx.x4.organization.max_fullname': 'Full Name is invalid',
    'com.asyx.x4.organization.nofill_contactPerson': 'Contact Person should contain a value',
    'com.asyx.x4.organization.onlyAlphanumeric_contactPerson': 'Contact Person is invalid',
    'com.asyx.x4.organization.max_contactPerson': 'Contact Person is invalid',
    'com.asyx.x4.organization.nofill_email': 'Contact Person Email should contain a value',
    'com.asyx.x4.organization.invalidFormat_email': 'Contact Person Email is invalid',
    'com.asyx.x4.organization.max_email': 'Contact Person Email is invalid',
    'com.asyx.x4.organization.nofill_contactPersonPhone':
        'Contact Person Phone should contain a value',
    'com.asyx.x4.organization.onlyAlphanumeric_contactPersonPhone':
        'Contact Person Phone is invalid',
    'com.asyx.x4.organization.max_contactPersonPhone': 'Contact Person Phone is invalid',
    'com.asyx.x4.organization.nofill_city': 'City should contain a value',
    'com.asyx.x4.organization.max_city': 'City is invalid',
    'com.asyx.x4.organization.nofill_timeZone': 'Timezone should contain a value',
    'com.asyx.x4.organization.nofill_country': 'Country should contain a value',
    'com.asyx.x4.organization.max_country': 'Country is invalid',
    'com.asyx.x4.organization.nofill_address1': 'Address should contain a value',
    'com.asyx.x4.organization.max_address1': 'Address is invalid',
    'com.asyx.x4.organization.nofill_registrationNumber':
        'Registration Number should contain a value',
    'com.asyx.x4.organization.nofill_contactPersonDepartment':
        'Contact Person Department should contain a value',
    'com.asyx.x4.organization.onlyAlphabetic_contactPersonDepartment':
        'Contact Person Department is invalid',
    'com.asyx.x4.organization.max_contactPersonDepartment': 'Contact Person Department is invalid',
    'com.asyx.x4.document.between5to50_refrence':
        'Invoice reference length should be between 5 and 50',
    'com.asyx.x4.invoice.mustPositive_amount': 'The amount should be positive value',
    'com.asyx.x4.document.nofill_currency': 'Please select the currency',
    'com.asyx.x4.invoice.nofill_buyerSeller': 'Buyer Name and Seller Name should contain a value !',
    'com.asyx.x4.invoice.nofill_amount': 'Total Amount should contain a value !',
    'com.asyx.x4.invoice.nofill_invoiceReference': 'Invoice reference should contain a value !',
    'com.asyx.x4.invoice.nofill_invoiceDate': 'Invoice Date should contain a value !',
    'com.asyx.x4.invoice.nofill_maturityDate': 'Maturity Date should contain a value !',
    'com.asyx.x4.invoice.nofill_billOfLadingDate': 'Bill of Lading Date should contain a value !',
    'com.asyx.x4.finprocess.statement.router.credit_limit_exceeded':
        'Financing Statement Has Exceeded The Participant Limit',
    'com.asyx.x4.finprocess.statement.router.credit_limit_contract_exceeded':
        'Financing Statement Has Exceeded The Contract Limit',
    'com.asyx.x4.finprocess.statement.router.requestor_suspend':
        'Requester has been suspended. Please settle existing overdue outstanding transactions to request for new funding.',
    'com.asyx.x4.finprocess.statement.router.suspend_contract':
        'Your account is frozen. Please contact the administrator.',
    'com.asyx.x4.finprocess.statement.router.negative_funded_amount':
        'Funded amount should not be zero or negative.',
    'com.asyx.x4.contract.used_in_transaction':
        'Failed to delete the contract as it was already used by other transaction(s).',
    'com.asyx.x4.error.unknown': 'Unknown error occured, please try again later.',
    'com.asyx.x4.error.network':
        'Failed to connect to the server, please check your internet connection.',
    'com.asyx.x4.document.between1to15_vehicleNumber': 'Panjang nomor kendaraan maksimum 15 digit',
    'com.asyx.x4.document.max15digit_totalAmount':
        'The total amount exceeds the system limit. Please revise and ensure it is not more than 15 digits.',
    deleteProgramConfirmation: 'Are you sure you want to delete program',
    cantUndo: "You can't undo this.",
    noPermissionDocumentView: "You don't have access to this document.",
    noDataFound: 'No Data Found.',
    'b2b.documentDetail': 'Document Details',
    'b2b.orderTo': 'Order To',
    'b2b.shipTo': 'Ship To',
    'b2b.orderInformation': 'Order Information',
    'b2b.poStatus': 'PO Status',
    'b2b.poDate': 'PO Date',
    'b2b.poExpiredDate': 'PO Expired Date',
    'b2b.poType': 'PO Type',
    'b2b.partialDelivery': 'Partial Delivery',
    'b2b.top': 'TOP',
    'b2b.producCode': 'Product Code',
    'b2b.productName': 'Product Name',
    'b2b.quantity': 'Quantity Order',
    'b2b.price': 'Unit Price',
    'b2b.items': 'Items',
    'b2b.discount': 'Disc : ',
    'b2b.discountAmount': 'Discount Amount',
    'b2b.luxuryTax': 'Luxury Tax',
    'b2b.totalPoAmount': 'Total PO Amount',
    'b2b.subtotal': 'Sub Total',
    'b2b.subTotalAfterDiscount': 'Sub Total After Discount',
    'b2b.npwp': 'NPWP',
    'b2b.telp': 'Telp',
    'b2b.attn': 'Attn',
    'b2b.fax': 'Fax',
    'b2b.customerInformation': 'Customer Information',
    'b2b.billingInformation': 'Billing Information',
    docstoreRole: 'Organization Role',
    'b2b.customer': 'Customer',
    volume: 'Volume',
    fixedPrice: 'Fixed Price',
    shortName: 'Short Name',
    validFrom: 'Valid From',
    minimumAmount: 'Minimum Amount',
    taxable: 'Taxable',
    priceTiers: 'Price Tiers',
    assignedEntities: 'Assigned Entities',
    'b2b.yes': 'Yes',
    'b2b.no': 'No',
    editPrice: 'Edit Price',
    priceDetail: 'Price Detail',
    pricingRules: 'Pricing Rules',
    processVariable: 'Process Variable',
    'com.b2b.shortName.isNull': 'Short Name is Required.',
    'com.b2b.validFrom.isNull': 'Valid From is Required.',
    'com.b2b.discount.isNull': 'Discount is Required.',
    'com.b2b.minimumAmount.isNull': 'Minimum Amount is Required.',
    'com.b2b.amount.isNull': 'Amount is Required.',
    'com.b2b.priceTiers.isEmpty': 'There should be a minimum of 1 Price Tier.',
    'com.b2b.priceTier.volume.isEmpty': 'Volume on Price Tier cannot be empty.',
    'com.b2b.priceTier.fixedPrice.isEmpty': 'Fixed Price on Price Tier cannot be empty.',
    'com.b2b.priceTier.percentage.isEmpty': 'Percentage on Price Tier cannot be empty.',
    'com.b2b.priceTier.processVariable.isEmpty': 'Process Variable on Price Tier cannot be empty.',
    priceMaintenance: 'Price Maintenance',
    countryISOCode: 'Country ISO Code',
    faxNumber: 'Fax Number',
    customerName: 'Customer Name',
    settleOrRevise: 'Settle or Revise',
    billingStatements: 'Billing Statements',
    customer: 'Customer',
    registrationNo: 'Registration No',
    revision: 'Revision',
    statementDate: 'Statement Date',
    minimumFee: 'Minimum Fee',
    specification: 'Specification',
    valueAddedTax: 'Value Added Tax (VAT)',
    requestedDisbursementDate: 'Requested Disbursement Date',
    requestedSettlementDate: 'Requested Settlement Date',
    signature: 'Signature',
    signatureSender: 'Sender:',
    signatureReceiver: 'Receiver:',
    signatureDate: 'Date:',
    signatureApproved: 'Approved By: Board Of Director',
    addressOne: 'Address One',
    addressTwo: 'Address Two',
    'No Data Available': 'No Data Available',
    'com.asyx.x4.user.password_missmatch': "Current password doesn't match",
    'com.asyx.x4.uoa.updatepassword.invalid_length':
        'Your password must contain at least 9 characters in length.',
    'com.asyx.x4.uoa.updatepassword.no_symbol': 'Your password must contain a symbol.',
    'com.asyx.x4.uoa.updatepassword.no_number': 'Your password must contain a number.',
    'com.asyx.x4.uoa.updatepassword.no_upper_case':
        'Your password must contain upper case letters.',
    'com.asyx.x4.uoa.updatepassword.no_lower_case':
        'Your password must contain lower case letters.',
    'com.asyx.x4.uoa.updatepassword.contain_space': 'Your password cannot contain space.',
    'com.asyx.x4.uoa.updatepassword.contain_symbol_number':
        'Your password must contain symbol and number.',
    'com.asyx.x4.uoa.updatepassword.symbol_number_upper':
        'Your password must contain symbol, number and upper case.',
    'com.asyx.x4.uoa.updatepassword.symbol_number_lower':
        'Your password must contain symbol, number and lower case.',
    'resetPassword.maximumAttempt': 'Too many attempts. (Maximum of 3 times a day)',
    'com.asyx.x4.user.password_has_been_used':
        'This password has been used before. Please choose a new password.',
    'com.asyx.x4.user.password_has_been_used_default':
        'This password has been used before. Please choose a new password.',
    'com.asyx.x4.user.password_has_been_used_bni':
        'This password has already been used. Please choose a different one.',
    'com.asyx.x4.uoa.updatepassword.contain_forbidden_special_characters':
        'Your password contain forbidden special characters (& % =).',
    confirmPassword: 'Confirm Password',
    passwordResetSuccess: 'Password updated, redirecting you to login page in ',
    orClick: 'or click',
    here: 'here',
    showUploadProductTips: 'To register a large list of products, you can upload files in ',
    thisPage: 'this page',
    dontRemind: "Don't remind",
    goToLoginPage: ' to go now.',
    signatureName: 'Name:',
    transferAfterGR: 'Transfer After Good Received',
    transferAfterQualityApproval: 'Transfer After Quality Approval',
    transferAfterGRValidation: 'Transfer After Good Received should contain a value.',
    transferAfterQualityApprovalValidation:
        'Transfer After Quality Approval should contain a value',
    'Apr On Asset Amount': 'APR on Asset Amount',
    'Apr On Disbursement Amount': 'APR on Disbursement Amount',
    'Apr On Eligible Amount': 'APR on Eligible Amount',
    'Apr On Original Amount': 'APR on Original Amount',
    'Percentage Of Asset Amount': '% of Asset Amount',
    'Percentage Of Disbursement Amount': '% of Disbursement Amount',
    'Percentage Of Eligible Amount': '% of Eligible Amount',
    'Percentage Of Original Amount': '% of Original Amount',
    accountEnabled: 'Account Enabled',
    accountDisabled: 'Account Disabled',
    accountLocked: 'Account Locked',
    accountUnlocked: 'Account Unlocked',
    unlockAccount: 'Unlock Account',
    showMore: 'Show More ...',
    showMoredata: 'Show More',
    showLessdata: 'Show Less',
    viewJobExecution: 'View Execution',
    apmsReference: 'APMS Reference',
    viewJobInstances: 'View Instances',
    totalPO: 'Number of PO',
    percentage_of_asset_amount: '% of Asset Amount',
    percentage_of_disbursement_amount: '% of Disbursement Amount',
    percentage_of_eligible_amount: '% of Eligible Amount',
    percentage_of_original_amount: '% of Original Amount',
    apr_of_asset_amount: 'APR of Asset Amount',
    apr_of_disbursement_amount: 'APR of Disbursement Amount',
    apr_of_eligible_amount: 'APR of Eligible Amount',
    apr_of_original_amount: 'APR of Original Amount',
    apr_of_remaining_disbursement_amount: 'APR of Remaining Disbursement Amount',
    calculationTypeValue: 'Type',
    calculationType: 'Calculation Type',
    penaltyCalculationType: 'Penalty Calculation Type',
    signatures: 'Signatures',
    principalAmount: 'Principal Amount',
    exportCsv: 'Export CSV',
    exportPdf: 'Export PDF',
    exportExcel: 'Export XLS',
    exportXml: 'Export XML',
    exportMt940: 'Export MT940',
    exportProcessingMessage: 'We are processing your file, please wait...',
    'hover.accept.disbursement_approval':
        'Click on this button will disburse the Financing Statement.',
    'hover.accept.asset_financing_funder_approval':
        'Click on this button to proceed the Financing Statement document for disbursement initiation.',
    'hover.accept.asset_financing_requester_approval':
        'Click on this button to proceed the Financing Statement document to service provider or funder.',
    'hover.accept.service_provider_approval':
        'Click on this button to proceed the Financing Statement document to Funder approval.',
    'hover.reject.disbursement_approval':
        'Click on this button a rejection remark should be provided and the Financing Statement document will be fully rejected. Once rejected, Seller should initiate a new request in the future.',
    'hover.reject.asset_financing_funder_approval':
        'Click on this button will reject the Financing Statement document. Once rejected, Seller should initiate a new request in the future.',
    'hover.reject.service_provider_approval':
        'Click on this button will reject the Financing Statement document. Once rejected, Seller should initiate a new request in the future.',
    'hover.cancel.asset_financing_requester_approval':
        'Click on this button will cancel the Financing Statement initiation.',
    'hover.edit.service_provider_approval':
        'Click on this button to edit the Financing Statement document to upload supporting document(s).',
    'hover.edit.asset_financing_requester_approval':
        'Click on this button to edit the Financing Statement document to give an acknowledgement.',
    'hover.revise.disbursement_approval':
        'Click on this button a revision remark should be provided and the Financing Statement document will be sent back to the Funder Maker user for revision.',
    'Too many attempt':
        'Reset Password has been requested 3 times, please wait until next day or contact Asyx support',
    update: 'Update',
    discountType: 'Discount Type',
    dataConfirmation: 'Data Confirmation',
    dataHoverError: 'Error(s) found on this file.',
    dataHoverSuccess: 'File is good and ready to upload.',
    csvReviewErrors: 'Needs to be fixed first :',
    buyerReference: 'Buyer Reference',
    sellerReference: 'Seller Reference',
    settlementForm: 'Settlement Form',
    attachFiles: 'Attach Files',
    chooseFile: 'Choose File',
    addFile: 'Add File',
    settlementConfirmation: 'Settlement Confirmation',
    attachments: 'Attachments',
    createCreditNote: 'Create Credit Note',
    creditNote: 'Credit Note',
    beginingOfInvoiceAmount: 'Beginning of Invoice Amount',
    endingOfInvoiceAmount: 'Ending of Invoice Amount',
    creditNoteAmount: 'Credit Note Amount',
    history: 'History',
    loggingIn: 'Logging in...',
    updatePassword: 'Update Password',
    enterCurrentPassword: 'Please enter your current password',
    enterNewPassword: 'Please enter your new password',
    generalErrorMessage: 'Something went wrong, please contact our support for further assistance.',
    too_many_attempt:
        'Password has been submitted 3 times, please wait until next day or contact Asyx support.',
    assign: 'Assign',
    editCreditNoteAmount: 'Edit Credit Note Amount',
    assignCreditNote: 'Assign Credit Note',
    assignInvoice: 'Assign Invoice',
    selectInvoice: 'Select Invoice',
    interestIndexManagement: 'Interest Index Management',
    lastUpdate: 'Last Update',
    interestIndexDetail: 'Interest Index Detail',
    interestIndexEdit: 'Interest Index Edit',
    InterestIndexAdd: 'Interest Index Add',
    notificationTemplate: 'Notification Template',
    templateNotifCreated: 'Template notification has been created.',
    templateNotifUpdated: 'Template notification has been updated.',
    templateNotifDeleted: 'Template notification has been deleted.',
    fromDate: 'From Date',
    toDate: 'To Date',
    rateUpdates: 'Rate Updates',
    reconciliation: 'Reconciliation',
    reconciliationAmount: 'Reconciliation Amount',
    otherCharges: 'Other Charges',
    additionalReimbursement: 'Additional Reimbursement',
    difference: 'Difference',
    reconcile: 'Reconcile',
    reconciliationForm: 'Reconciliation Form',
    confirm: 'Confirm',
    'com.asyx.x4.reconciliation.nofill_buyer': 'Please pick at least 1 buyer.',
    'com.asyx.x4.reconciliation.nofill_currencies': 'Please pick at least 1 currency.',
    'com.asyx.x4.reconciliation.nofill_repaymentDate': 'Repayment Date Must be Filled.',
    'com.asyx.x4.reconciliation.invalid_repayment_amount': 'Repayment Amount cannot be empty.',
    'com.asyx.x4.reconciliation.invalid_difference_amount': 'The Difference should be zero.',
    'com.asyx.x4.finconfig.referencesource.service.duplicate_combination_name_and_configuration':
        'Name and Configuration is already used.',
    'com.asyx.x4.finconfig.referencesource.service.duplicate_combination_name_and_days':
        'Configuration and Days is already used.',
    creditNoteReference: 'Credit Note Reference',
    switchUserType: 'Switch User Type',
    selectUserType: 'Select User Type',
    supplier: 'Supplier',
    quoteFormLoading: 'Preparing your form, please wait...',
    noLineItems: 'No items added.',
    moneyMovementReport: 'Money Movement Report',
    trannsactionType: 'Transaction Type',
    responseType: 'Response Type',
    inactiveDialogTitle: 'Hi, are you still there?',
    inactiveDialogMessage:
        "For your account security, you will be automatically logged out if there's no activity after some time.",
    inactiveDialogButton: 'Yes, Please wait',
    tenor: 'Tenor',
    viewDetail: 'View Detail',
    switchUser: 'Switch User',
    totalUserSelected: 'Total User(s) selected : ',
    totalDocumentSelected: 'Total Document(s) selected : ',
    totalTaskSelected: 'Total Task(s) selected : ',
    cloneUser: 'Clone User',
    cloneUsernameValidation: '* Username must be different from the original user.',
    paymentInformation: 'Payment Information',
    priceType: 'Price Type',
    owner: 'Owner',
    'com.task.validation.emptyQc': 'Quality form must be filled.',
    'com.asyx.x4.qcvalidation.standardPercentage': 'Please fill in water quality.',
    'com.asyx.x4.qcvalidation.seedAmount': 'Please fill in seed amount.',
    'com.asyx.x4.qcvalidation.maxDirt': 'Please fill in maximum dirt.',
    'com.asyx.x4.qcvalidation.maxMushroom': 'Please fill in maximum mushroom.',
    'com.asyx.x4.qcvalidation.maxSkinContent': 'Please fill in maximum skin content.',
    'com.asyx.x4.qcvalidation.notSalty': 'Please fill in not salty.',
    calculating: 'Calculating...',
    settlementValidation: 'Settlement amount must be lower than or equal to remaining amount.',
    seedAmount: 'Seed Amount',
    maxDirt: 'Maximum Dirt',
    maxMushroom: 'Maximum Mushroom',
    maxSkinContent: 'Maximum Skin Content',
    notSalty: 'Is Not Salty',
    additional: 'Additional',
    startPeriod: 'start Period',
    inactivityPeriod: 'Inactivity Period',
    emailNotificationactivation: 'Email Notification Activation',
    activeEmailNotification: 'Active Email Notification',
    inActiveEmailNotification: 'Inactive Email Notification',
    documentStatusActivation: 'Show Document Read Status Activation',
    activeDocumentRead: 'Active Document Read Status',
    inActiveDocumentRead: 'Inactive Document Read Status',
    relativeTimeActivation: 'Show Relative Time Activation',
    activeRelativeTime: 'Active Show Relative Time',
    inActiveRelativeTime: 'Inactive Show Relative Time',
    otpActivation: 'One Time Password Activation',
    activeOtp: 'Active One Time Password',
    inActiveOtp: 'Inactive One Time Password',
    accountStatus: 'Account Status',
    enabledAccount: 'Account Enabled',
    disabledAccount: 'Account Disabled',
    lockedAccount: 'Account Locked',
    ldapAccount: 'LDAP Account',
    activeLdap: 'Active LDAP Account',
    inActiveLdap: 'Inactive LDAP Account',
    addBankInformation: 'Add Bank Information',
    supplierList: 'Supplier List',
    addSupplier: 'Add New Supplier',
    supplierEmail: 'Supplier Email',
    buyerList: 'Buyer List',
    addBuyer: 'Add New Buyer',
    buyerEmail: 'Buyer Email',
    phoneNumber: 'Phone Number',
    requiredNote: '* Required',
    createAnother: 'Add Another',
    addParticipantSuccess: ' Successfully added.',
    uncdfRegisterText: 'Complete your registration information',
    ageRange: 'Age Range',
    lessThan24: 'Under 24',
    over24: '24 or more',
    buyerOrSupplier: 'Are you a Buyer or Supplier ?',
    passwordDidNotMatch: '* Confirm password does not match.',
    usernameAlphanumeric: '* Username cannot contain special characters.',
    usernameMin5: '* Username has to be at least 5 characters.',
    passwordMin: '* Password has to be at least 9 characters.',
    passwordAlphanumeric:
        '* Password must contain: number, uppercase, special character and lowercase letter.',
    userCreated: 'Your account has been created.',
    clickHereToLogin: 'Click here to go to the login page.',
    usernameExists: '* This username is already taken.',
    registrationLinkExpired: 'This registration link is expired, please contact our support.',
    male: 'Male',
    female: 'Female',
    genderNull: 'Rather not to say',
    gender: 'Gender',
    next: 'Next',
    back: 'Back',
    organizationOrCompany: 'Organization / Company Name',
    profit: 'Estimated Profit',
    npwp: 'Tax Identification Number',
    numberOfEmployees: 'Number of Employees',
    community: 'Which community are you from ?',
    done: 'Done',
    userProfile: 'Profile',
    businessInformation: 'Business Information',
    accountInformation: 'Account Information',
    finish: 'Finish',
    tooltipUsername1: '- Minimum of 5 characters.',
    tooltipPassword1: '- Minimum of 9 characters.',
    tooltipPassword2: '- Must contain uppercase character(s) (A-Z).',
    tooltipPassword3: '- Must contain lowercase character(s) (a-z).',
    tooltipPassword4: '- Must contain number(s) (0-9).',
    tooltipPassword5: '- Must contain symbol(s) (ex. !, $, #, etc.).',
    organizationNotComplete: 'Before doing any transactions, please complete your business profile',
    alreadyExists: 'is already exists',
    hasCreated: 'has been created',
    billingStatus: 'Billing Status',
    actived: 'Actived',
    suspended: 'Suspended',
    activity: 'Activity',
    documents: 'Documents',
    accountSettings: 'Account Settings',
    logout: 'Logout',
    from: 'From',
    to: 'To',
    noTaskFound: 'No Task Found',
    success: 'Success',
    minimumRange: 'Minimum Range',
    maximumRange: 'Maximum Range',
    createProduct: 'Create Product',
    createInventory: 'Create Inventory',
    createForm: 'Create Form',
    updateForm: 'Update Form',
    form: 'Form',
    addAnswer: 'Add Answer',
    required: 'Required',
    formName: 'Form Name',
    formDescription: 'Form Description',
    manageForm: 'Manage Form',
    duplicate: 'Duplicate',
    fillForm: 'Fill Form',
    editForm: 'Edit Answer',
    viewForm: 'View Form',
    answerSubmitted: 'Answer submitted.',
    answer: 'Answer',
    keyword: 'Keyword',
    keywords: 'Keywords',
    suspensions: 'Suspensions',
    creditLimitExpiryDate: 'Credit Limit Expiry Date',
    forever: 'Forever',
    spesificDate: 'Spesific Date',
    overdueAmount: 'Overdue Amount',
    dashboard: 'Dashboard',
    tasks: 'Tasks',
    administration: 'Administration',
    users: 'Users',
    banks: 'Banks',
    roles: 'Roles',
    programs: 'Programs',
    contracts: 'Contracts',
    jobs: 'Jobs',
    file: 'File',
    auditTrail: 'Audit Trail',
    referenceSourceNav: 'Reference Source',
    reporting: 'Reporting',
    documentReport: 'Document Report',
    bookingOfficeMonitoringTools: 'Booking Office Monitoring Tools',
    customerReport: 'Customer Report',
    relationDetail: 'Relation Detail',
    transactionReport: 'Transaction Report',
    response: 'Response',
    transferDetailsReference: 'Transfer Detail Reference',
    statusTransfer: 'Status Transfer',
    fsStatus: 'Fs Status',
    narrative: 'Narrative',
    proposal: 'Proposal',
    transactionType: 'Transaction Type',
    financingReport: 'Financing Report',
    reportEngine: 'Report Engine',
    moneyMovement: 'Money Movement',
    createDocument: 'Create Document',
    quotes: 'Quotes',
    invoices: 'Invoices',
    accurate: 'Accurate',
    downpayment: 'Down Payment',
    inventory: 'Inventory',
    inventoryReport: 'Inventory Report',
    invoiceSettlement: 'Invoice Settlement',
    products: 'Products',
    contact: 'Contact',
    feeTemplate: 'Fee Template',
    feeManagement: 'Fee Management',
    chargesPlan: 'Charges Plan',
    executionPhaseFee: 'Execution Phase',
    outstanding: 'Outstanding',
    invoicedFee: 'Invoiced Fee',
    cycleFee: 'Cycle',
    nameFee: 'Name',
    confirmNewPasswordMsg: 'Please re-enter your new password',
    feeTemplateDetail: 'Fee Template Detail',
    feeName: 'Fee Name',
    executionPhase: 'Execution Phase',
    gracePeriod: 'Grace Period',
    oneTime: 'One Time',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    preCharges: 'Pre Charges',
    postCharges: 'Post Charges',
    initiate: 'Initiate',
    early: 'Early',
    extension: 'Extension',
    late: 'Late',
    tierType: 'Tier Type',
    static: 'Static',
    dynamic: 'Dynamic',
    formula: 'Formula',
    copy: 'Copy',
    none: 'None',
    void: 'Void',
    postPoned: 'Postponed',
    // new translation x4-6459
    signup: 'Sign Up',
    userNameMinimalValidation: 'Username has to be at least 5 character',
    userNameRequiredValidation: 'Username is required!',
    userNameMatchValidation: 'Username cannot contain special characters\n',
    nameMinimalValidation: 'Name has to be at least 5 characters',
    nameRequiredValidation: 'Name is required!',
    mobileNumberMinimalValidation: 'Mobile Number has to be at least 10 characters',
    mobileNumberRequiredValidation: 'Mobile Number is required!',
    emailAddressValidation: 'Invalid email address',
    emailAddressRequiredValidation: 'Email is required!',
    passwordMinimalValidation: 'Password has to be at least 9 characters!',
    passwordMatchValidation:
        'Password must contain: numbers, uppercase, special characters and lowercase letters\n',
    passwordRequiredValidation: 'Password is required!',
    confirmPassValidation: 'Password must match',
    confirmPassRequiredValidation: 'Password confirmation is required!',
    captchaRequiredValidation: 'Captcha is required!',
    registerSuccessMessage:
        'The username can be verified after a submission and the captcha is updated if the username is already taken',
    createAccountSuccessMessage: 'Success to Create Account',
    hoverInformation: 'Hover on ',
    hoverDescription: ' icon to show full decimal amount',
    available: 'Available',
    completed: 'Completed',
    transactionWidget: 'Transaction',
    overdueTab: 'Overdue',
    outstandingTab: 'Outstanding',
    transactionValue: 'Top Transaction Value',
    viewFullList: 'View Full List',
    maximum: 'Maximum',
    all: 'All',
    upcomingSettlements: 'Upcoming Settlements',
    upcomingSettlementEmailNotification: 'Upcoming Settlement Email Notification',
    participantName: 'Participant Name',
    number: 'Number',
    financingOverview: 'Financing Overview',
    balanceWidget: 'Balance Widget',
    verifyEmail: 'Verify Email',
    inventoryList: 'Inventory List',
    inventoryDetail: 'Inventory Detail',
    inventoryDetailByDate: 'Inventory Detail Per Date',
    roleAdd: 'Role Add',
    roleEdit: 'Role Edit',
    createUserProfile: 'Create User Profile',
    editUserProfile: 'Edit User Profile',
    editUser: 'Edit User',
    createOrganization: 'Create Organization',
    editOrganization: 'Edit Organization',
    createCalendar: 'Create Calendar',
    editCalendar: 'Edit Calendar',
    createAuthorization: 'Create Authorization',
    editAuthorization: 'Edit Authorization',
    organizationAuthDetail: 'Organization Authorization Detail',
    createSales: 'Create Sales',
    editSales: 'Edit Sales',
    fileExport: 'File Export',
    auditTrailDetail: 'Audit Detail',
    // new translation x4-6459
    noAttachmentAdded: 'No attachment added.',
    statusHistory: 'Status History',
    currentState: 'Current State',
    exemption: 'Exemption',
    totalDataSelected: 'Total data selected : ',
    creditLimitExpiryDateRemark:
        'Credit limit facility is expired, please renew it by contacting the funder.',
    creditLimitModal: 'The Credit facility for this organization is expired, continue anyway ?',
    bypassFunder: 'Bypass Funder',
    originAccount: 'Origin Account',
    destinationAccount: 'Destination Account',
    bulkFinancing: 'Bulk Financing',
    fundAllocation: 'Fund Allocation',
    fundAllocationRateBelow100: 'Rate allocation should be 100%.',
    fundAllocationRateAbove100: 'Rate allocation should be 100%.',
    fundAllocationOriginEmpty: 'Please select origin account.',
    fundAllocationDestinationEmpty: 'Please select destination account.',
    fundAllocationSubmitted: 'Fund allocation submitted.',
    amortizationDate: 'Amortization Date',
    amortizationHistory: 'Amortization History',
    amortizationAmount: 'Amortization Amount',
    addProperty: 'Add Property',
    valueType: 'Value Type',
    extensionRequest: 'Extension Request',
    extensionTenor: 'Extension Tenor',
    activation: 'Activation',
    feeSettings: 'Fee Settings',
    settlementExtension: 'Settlement Extension',
    settlementExtensionSetting: 'Settlement Extension Setting',
    addRabate: 'Add Rebate',
    rabate: 'Rebate',
    rabateSetting: 'Rebate Setting',
    rebateTiering: 'Rebate Tiering',
    vatPercentage: 'Persentase PPN',
    bulkExtension: 'Bulk Extension',
    bulkExtensionRequestForm: 'Bulk Extension Form',
    settlementExtensionRequestForm: 'Settlement Extension Form',
    selectedDocuments: 'Selected Document(s)',
    extensionDueDate: 'Extension Due Date',
    extensionHistory: 'Extension History',
    extensionFee: 'Extension Fee',
    settlementExtensionDueDate: 'Settlement Extension Due Date',
    settlementExtensionHistory: 'Settlement Extension History',
    settlementExtensionFee: 'Settlement Extension Fee',
    settlementExtensionTenor: 'Settlement Extension Tenor',
    dueDateLessThanMaturityDate: 'Extension Due Date must be more than Maturity Date.',
    pickDate: 'Click to select a date...',
    // Extension validations
    'com.asyx.x4.finprocess.extension.not_found.financing_statement':
        'Financing statement(s) not found.',
    'com.asyx.x4.finprocess.extension.invalid_tag':
        'Invalid status/tag. Allowed status/tag is DISBURSED/EXTENDED.',
    'com.asyx.x4.finprocess.extension.invalid_disbursement': 'Disbursement not found.',
    'com.asyx.x4.finprocess.extension.multi_payment_date':
        'Cannot process financing statements with multi payment date of disbursement.',
    'com.asyx.x4.finprocess.extension.multi_financing_tenor':
        'Cannot process financing statements with multi financing tenor of disbursement.',
    'com.asyx.x4.finprocess.extension.multi_tag':
        'Cannot process financing statements with different status.',
    'com.asyx.x4.finprocess.extension.multi_contract':
        'Cannot process financing statements with different contract.',
    'com.asyx.x4.finprocess.extension.multi_recourse':
        'Cannot process financing statements with different recourse.',
    'com.asyx.x4.finprocess.extension.multi_currency':
        'Cannot process financing statements with different currency.',
    'com.asyx.x4.finprocess.extension.not_found.contract_participant_stage':
        'Contract Participant Stage not found.',
    'com.asyx.x4.finprocess.extension.restriction.extension_tenor':
        'Extension tenor more than maximum extended tenor.',
    'com.asyx.x4.finprocess.extension.restriction.invalid_due_date':
        'Extension due date should be less than maximum extended tenor or remaining tenor.',
    'com.asyx.x4.finprocess.extension.waiting_approval.extension':
        'Cannot request extension because document(s) is waiting for approval or already extended.',
    extensionRequested: 'Extension request submitted.',
    settlementExtensionRequested: 'Settlement extension request submitted.',
    'com.asyx.x4.finprocess.extension.restriction.deselect_all':
        'Please select at least one financing statement, or reject the task instead.',
    'com.asyx.x4.finprocess.extension.restriction.unregistered_financing_statement':
        'Error! Unregistered financing statement.',
    'com.asyx.x4.finprocess.extension.restriction.tenor_exceed': 'Tenor exceeded maximum',
    'com.asyx.x4.organizationFreeze':
        'Organization is freeze. Please check Credit Limit Expiry Date / Credit Rating / Overdue Transaction. Please contact Bank Administrator.',
    'com.asyx.x4.contractFreeze':
        'Contract is freeze, has occurred overdue amount / overdue days. Please contact Bank administrator.',
    extensionDetail: 'Extension Detail',
    settlementExtensionDetail: 'Settlement Extension Detail',
    extensionID: 'Extension ID',
    extendedDueDate: 'Extended Due Date',
    extensionType: 'Extension Type',
    transferDetails: 'Transfer Details',
    retry: 'Retry',
    retryBookingOffice: 'Retry Booking Office',
    bookingOfficeExecutionHistory: 'Booking Office Execution History',
    lastExecutionStartTime: 'Last Execution Start Time',
    lastExecutionEndTime: 'Last Execution End Time',
    duration: 'Duration',
    executions: 'Executions',
    executedBy: 'Executed By',
    beginningStatus: 'Initial Status',
    endStatus: 'Final Status',
    executionDateTime: 'Execution Date & Time',
    deliveryLocation: 'Delivery Location',
    expetedInvoiceMaturityDate: 'Expeted Invoice Maturity Date',
    descriptionNull: 'Item Description must be filled',
    totalAssetPercentage: 'Total Asset Percentage',
    transactionInquiry: 'Transaction Inquiry',
    periodInquiry: 'Period',
    beginningBalance: 'Beginning Balance',
    totalDebit: 'Total Debit',
    totalCredit: 'Total Credit',
    postDate: 'Post Date',
    journalNo: 'Journal No.',
    debitOrCredit: 'Db/Cr',
    balance: 'Balance',
    configurationTools: 'Configuration Tools',
    participant: 'Participant',
    parameterType: 'Parameter Type',
    freezed_account: 'Freezed Account',
    unfreezed_account: 'Unfreezed Account',
    proposal_after_office_hour: 'Proposal After Office Hour',
    manual_proposal_creation: 'Manual Proposal Creation',
    without_transfer_approval: 'Without Transfer Approval',
    credit_limit_expired_date: 'Credit Limit Expired Date',
    vatNull: 'Vat must be filled or selected',
    pageNumber: 'Page Number',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    expectedInvoiceMaturityDate: 'Expected Invoice Maturity Date',
    outstandingTransactions: 'Outstanding Transactions',
    fscmOutstanding: 'FSCM Outstanding',
    iconsOutstanding: 'iCons Outstanding',
    addDocumentLink: 'Add Document Link',
    documentLink: 'Document Link',
    selectOrder: 'Select Order',
    financingAfterCutOffTime: 'Financing After Cut Off Time',
    rowsPerPage: 'Rows per page',
    payFees: 'Pay Fees',
    cifNumber: 'CIF Number',
    branchInformation: 'Branch',
    synchronize: 'Synchronize',
    yes: 'Yes',
    not: 'No',
    ok: 'Ok',
    syncOrganizationConfirmationTitle: 'Sync Organization Data',
    syncOrganizationConfirmationMessage: "Do you want to sync this organization's data?",
    synchronizeSuccessMessage: 'Synchronization process completed.',
    bulkSyncOrganizationConfirmationMessage: 'Do you want to sync these organization data(s)?',
    failed: 'Failed',
    result: 'Result',
    reason: 'Reason',
    'com.asyx.x4.uoa.synchronize.failed.not_deposit': 'Account type is not deposit.',
    'com.asyx.x4.uoa.synchronize.failed.not_available': 'Account number is not available.',
    'com.asyx.x4.uoa.synchronize.failed.no_giro': 'Organization does not have giro account.',
    syncContractConfirmationTitle: 'Sync Contract Data',
    syncContractConfirmationMessage: "Do you want to sync this contract's data?",
    bulkSyncContractConfirmationMessage: 'Do you want to sync these contract data(s)?',
    'com.asyx.x4.finconfig.synchronize.failed.account_number_not_found':
        'Organization does not have account number.',
    'com.asyx.x4.finconfig.synchronize.failed.no_data_from_icons':
        'No response from iCons, potentially invalid CIF number.',
    'com.asyx.x4.finconfig.synchronize.failed.contract_participant_not_found':
        'Contract participants not found.',
    bulkSettleConfirmation: 'Bulk settle confirmation',
    bulkSettleConfirmationMsg: 'The difference is not equal to zero',
    bulkSettleConfirmationDetail:
        '* If you wish to continue this process, please click the button below',
    'login.invalidUsernamePassword': 'Invalid Username/Password, please try again.',
    'login.expiredPassword': 'Password expired, please contact administrator.',
    'login.accountLocked': 'Account is locked, please contact administrator',
    'login.generalFailure': 'Failed to connect to the server, please try again.',
    welcomeText: 'Welcome to ASYX X4',
    signin: 'Sign in',
    welcome: 'Welcome to ',
    bniService: 'BNIdirect Supply Chain',
    loginToYourAccount: 'Log in to your Account',
    checkMail: 'Check your mail',
    resetPasswordInstructionMsg: 'We have sent password recovery instructions to your email.',
    'com.asyx.x4.invalid_captcha': 'Invalid captcha.',
    serverStatus: 'Server Status',
    bniContactUs: 'Contact Us',
    bniWelcomeText: 'Welcome to BNI FSCM service',
    creditDebitNote: 'Credit/Debit Note',
    others: 'Others',
    bniRedirectErrorMsg: 'Please redirect again, your session has expired.',
    bniRedirectManualLogin: 'Log in manually here',
    bniRedirectSuccessMsg: 'Successfully logged in, we will redirect you to the portal shortly...',
    bniRedirectSuccessManual: "Click here if you haven't been redirected in 5 seconds.",
    bulkSettlement: 'Bulk Settlement',
    bulkSettlementConfirmation: 'Proceed bulk settlement with these documents?',
    bulkSettlementFailed: 'Bulk Settlement process failed.',
    acceptTask: 'Task Confirmation',
    bulkAcceptTaskApiConfirmation: 'Confirm the task proceeding with these document?',
    bulkAcceptTaskApiFailed: 'Accept task process failed.',
    'com.asyx.x4.finprocess.settlement.invalid-size':
        'The number of selected Financing Statements should at least 1 or less-than or equal to 100 documents.',
    'com.asyx.x4.finprocess.settlement.create.invalid-status':
        'Only DISBURSED, PARTLY SETTLED, EXTENDED or SETTLEMENT EXTENDED Financing Statements are allowed to be requested.',
    'com.asyx.x4.finprocess.settlement.edit.invalid-status':
        'The selected Financing Statements should have the status PENDING SETTLEMENT.',
    'com.asyx.x4.finprocess.settlement.invalid-currency':
        'The selected Financing Statements should have the same currency',
    'com.asyx.x4.finprocess.settlement.invalid-relation':
        'The selected Financing Statements should have the same organization relationships.',
    'com.asyx.x4.finprocess.settlement.invalid-payment-date':
        'The selected Financing Statements should have the same disbursement payment date.',
    'com.asyx.x4.uoa.organization.failed-delete': 'Data is being used in other relations.',
    'com.asyx.x4.organization.used':
        'Failed to delete organization, organization has been on contract. Please check again.',
    'com.asyx.x4.constraint': 'The organization has been link to Authorization.',
    uploadSettlement: 'Upload Settlement',
    FinancingStatementReference: 'Financing Statement Reference',
    RepaymentDate: 'Repayment Date',
    RepaymentAmount: 'Repayment Amount',
    ResidualTransferDate: 'Residual Transfer Date',
    level: 'Level',
    showApprovers: 'View Approvers',
    approver: 'Approver',
    help: 'Help',
    helpBookingOffice:
        'Booking Office is a functional feature for carrying out transactions with integration on the Icon. Users can perform transactions using Icon integration by activating the available toggles (Disbursement, Settlement or both).',
    helpErrorMsg: 'Help document failed to load, click to try again',
    childs: 'Child Company',
    limitSettings: 'Limit Settings',
    followsContractLimit: 'Follows Contract Limit',
    checkNetPlafond: 'Check Net Plafond',
    limitAllocation: 'Limit Allocation',
    allocationPercentage: 'Allocation Percentage',
    allocationPercentageValidation: 'Total allocation must not exceeds 100%',
    exports: 'File Exports',
    propertyConfiguration: 'Property Configurations',
    penalties: 'Penalties',
    outstandingParameters: 'Outstanding Parameters',
    disbursementPhases: 'Disbursement Phases',
    settlementPhases: 'Settlement Phases',
    settlementExtensionPhases: 'Settlement Extension Phases',
    accounts: 'Accounts',
    generalLedgerSf: 'Booking GL SF Setting',
    generalLedgerDf: 'Booking GL DF Setting',
    generalLedgerSd: 'Booking GL SD Setting',
    data: 'Data',
    message: 'Event',
    auditTags: 'Tag',
    timestamp: 'Timestamp',
    reconciliationReport: 'Reconciliation Report',
    totalResiduals: 'Total Residuals',
    adjustmentBankCharges: 'Adjustment - Bank Charges',
    adjustmentCreditNote: 'Adjustment - Credit Note',
    adjustmentOthers: 'Adjustment - Others',
    process: 'Process',
    ipAddress: 'IP Address',
    field: 'Field',
    before: 'Before',
    after: 'After',
    eventDetail: 'Event Detail',
    noAdditionalData: 'No additional data',
    holidayList: 'Holiday List',
    emptyExclusions: '* Please provide date on every exclusion dates',
    downloadTemplate: 'Download Template',
    uploadOrganizationCalendar: 'Upload Organization Calendar',
    fileSelected: 'File selected',
    fileUploaded: 'File successfully uploaded.',
    holidayFinancingStatement: 'Holiday Financing Statement',
    autoSettlementDetails: 'Auto Settlement Details',
    deleteCalendar: 'Delete Calendar',
    oldData: 'Old Data',
    newData: 'New Data',
    cannotDeletePastDate: 'Past dates or today cannot be deleted.',
    invoiceList: 'Invoice List',
    'com.asyx.x4.document.duplicate_invoice_reference':
        'Unable to update document, there are duplicate reference(s).',
    invoiceApproval: 'Invoice Approval',
    documentInformation: 'Document Information',
    invoiceApprovalEditFirst: 'You need to click the Edit button first.',
    referenceAlreadyExist: 'Reference already exist.',
    invalidReference: 'Invalid reference value.',
    fileTooLarge: 'Maximum File Size 50 MB',
    checking: 'Checking...',
    calendarDateAlreadyExist: 'Calendar date already exist, Please kindly select another date.',
    otpSmsForm: 'One Time Password SMS',
    otpEmailForm: 'One Time Password Email',
    'com.asyx.x4.invoices.exceeds_limit': 'Invoice amount exceeds available limit',
    automaticDisbursement: 'Automatic Disbursement',
    passwordUpdated: 'Your password has been successfully changed.',
    otpSent: 'An OTP code has been sent to ',
    pleaseVerifyOtpBelow: ', please verify it below.',
    didNotReceiveOtp: 'Did not receive OTP code?',
    resendOtp: 'Resend OTP',
    verifyOtp: 'Verify OTP',
    'com.asyx.x4.incorrect_otp': 'Incorrect OTP code.',
    jobExecutionEnabled: 'Job Execution Enabled',
    addConfiguration: 'Add Configuration',
    normalPaymentValue: 'Normal Payment Value',
    bulkExtensionError:
        'Bulk extension not yet configured for this transaction, please check your contract or contact administrator.',
    bulkSettlementExtensionError:
        'Settlement Extension not yet configured for this transaction, please check your contract or contact administrator.',
    chooseDate: 'Click to select a date...',
    maxFileSize: 'Max. file size',
    onlyAcceptFileType: 'Only accept file type:',
    plafond: 'Plafond',
    disponible: 'Disponible',
    holdAmount: 'Hold Amount',
    netPlafond: 'Net Plafond',
    loadingCaptcha: 'Loading captcha...',
    reloadCaptcha: 'Generate new captcha',
    enterCaptcha: 'Enter captcha',
    reloadCaptchaDelay: 'second(s) before able to generate new captcha.',
    tools: 'Tools',
    activityTools: 'Activity Tools',
    activityHistory: 'Activity History',
    submitDuplicateMessage: 'Please check again for these item code',
    submitDuplicate: 'Duplicate Confirmation',
    collaborationCreditLimit: 'Collaboration Credit Limit',
    rateChanges: 'Rate Changes',
    uploadRate: 'Upload Rate',
    referenceRatePercentage: 'Reference Rate Percentage',
    funderSpreadPercentage: 'Funder Spread Percentage',
    sharedRevenuePercentage: 'Shared Revenue Percentage',
    brokerFeePercentage: 'Broker Fee Percentage',
    technologyFeePercentage: 'Technology Fee Percentage',
    processingFeePercentage: 'Processing Fee Percentage',
    collectionFeePercentage: 'Collection Fee Percentage',
    commissionFeePercentage: 'Commission Fee Percentage',
    othersFeePercentage: 'Others Fee Percentage',
    financingStatement: 'Financing Statement',
    rateChangeApproval: 'Rate Change Approval',
    changeDate: 'Changed Date',
    quoteRestriction: 'Quote Restriction',
    quoteRestrictionDays: 'Quote Restriction Days',
    announcement: 'ANNOUNCEMENT',
    quoteRestrictionChecking: 'Please wait, Checking the quote restriction.',
    contractNameEmpty: 'Missing information: Contract Name!',
    currencyContractLimitSettingEmpty: 'Please select Currency on Limit Contract Setting!',
    maximumCreditLimitOnContractExceed: 'The Maximum Credit Limit is too large!',
    maximumCreditLimitContractEmpty: 'Missing information: Maximum Credit Limit!',
    overridePercentageContractEmpty: 'Missing information: Override Percentage!',
    optionRatesCurrencyEmpty: 'Please select Currency on Number of Days Divisor!',
    optionRatesDivisorEmpty: 'Please select Divisor on Number of Days Divisor!',
    proposalRejectionDaysEmpty: 'Missing information: Proposal Rejection Days!',
    minimumFinancingTenorEmpty: 'Missing information: Minimum Financing Tenor!',
    signatureMessage:
        'Hereby, we confirm that we agree to the details of this Financing Statement.',
    changeAppLogo: 'Change App Logo',
    resetAppLogo: 'Reset App Logo',
    changeLogo: 'Change Logo',
    serviceActionTeam: 'Service Action Team (SAT)',
    transactionPin: 'Transaction PIN',
    updateTransactionPin: 'Update PIN',
    enterCurrentPin: 'Please enter your current PIN',
    enterNewPin: 'Please enter your new PIN',
    confirmNewPinMsg: 'Please re-enter your PIN',
    validationUpdatePinMessage: '* PIN must be minimal 6 numbers',
    pinDidNotMatch: '* Confirm PIN does not match.',
    blockPin: 'Block PIN',
    unblockPin: 'Unblock PIN',
    pinVerification: 'Verification',
    forgotPin: 'Forgot PIN ?',
    successForgotPin: 'Successfully forgot PIN, please check your email.',
    pinUpdated: 'Your PIN has been successfully changed.',
    createPin: 'Create PIN',
    maximumFinancingTenorValidation: 'Maturity Date should be less than Maximum Financing Tenor!',
    maximumCreditLimitValidation: 'Amount Should be less than Maximum Credit Limit!',
    pleaseInputPin: 'Enter your 6-digit Transaction PIN',
    overpayment: 'Overpayment',
    underpayment: 'Underpayment',
    pph23: 'PPH23',
    amountDue: 'Amount Due',
    b2bPayment: 'Payment',
    taskDetailEditInformation: 'Please review the document and acknowledge the details',
    totalSettlementAmount: 'Total Settlement Amount',
    fundAvailable: 'Fund Available',
    pranota: 'Pra Nota',
    receivedDate: 'Received Date',
    uploadPraNota: 'Upload Pra Nota',
    pleaseSelectCommisionRateCurrency: 'Please select Currency on Commission Rate Settings!',
    pleaseSelectReferenceRateCurrency: 'Please select Currency on Reference Rate Settings!',
    pleaseSelectRebateCurrency: 'Please select Currency on Rebate Settings!',
    principal: 'Principal',
    linkedDocumentInformation: 'Linked Document Information',
    referenceDate: 'Reference Date',
    giroAccountMissing: 'Please set Giro Account to Recourse Configuration!',
    contractNotFoundBuyer: 'Contract not found for buyer',
    andSupplier: 'and supplier',
    currencyFor: 'Currency for',
    isIrrelevantExistingContract: 'is irrelevant with the existing contract',
    isIrrelevantExistingContractCurrency: 'is irrelevant with the existing contract',
    for: 'for',
    shouldContainValue: 'should contain a value',
    lengthBetween5and50: 'Reference length should be between 5 and 50',
    shouldPositiveAmount: 'should be positive amount',
    isInvalidReference: 'is invalid reference',
    rowCannotEmpty: 'Row data cannot be empty',
    cannotNegativeValue: 'cannot be negative value',
    cannotMoreThan100: 'cannot more than 100',
    cannotFutureDate: 'cannot be a future date',
    cannotLessThan: 'cannot be less than',
    cannotLessThanToday: 'cannot be less than today',
    lengthShouldLessThan255Characters: 'length should be less than 255 characters',
    formatCNDNincorrect:
        'format is incorrect, CN / DN Amount should only numeric, no characters or symbols allowed',
    formatRTRNincorrect:
        'format is incorrect, RTRN Amount should only numeric and always in negative, no characters or symbols allowed except -',
    formatARincorrect:
        'format is incorrect, AR Amount should only numeric and always in positive, no characters or symbols or negative amount allowed',
    formatIncorrect: 'format is incorrect',
    amountShouldNumeric:
        'Amount should only numeric and always in positive, no characters or symbols or negative amount allowed',
    totalAmountMoreThanZero: 'Total amount must more than zero, references',
    withTotalAmount: 'with total amount',
    shouldMore5And365days: 'Payment Term should be more than 0 and less than 365 days',
    activeOrganizationNotRelevant:
        'Active organization is not relevant with the row organization data',
    formatIncorect: 'format incorect',
    formatIsNotCorrect: 'Format is not correct for',
    shouldBeYYYYMMDD: 'It should be YYYYMMDD',
    amountFormatIncorect: 'Format',
    invoiceCode: 'Invoice Reference',
    invoiceamount: 'Invoice Amount',
    numberToDate: 'Payment Term',
    Reference: 'Referensi',
    maximalAmountMsg:
        'The total amount exceeds the system limit. Please revise and ensure it is not more than 15 digits.',
    shortMaximalAmountMsg: 'Total amount cannot more than 15 digits',
    shortMaximalAmountRowMsg: 'Amount cannot more than 15 digits',
    invoicereference: 'Invoice Reference',
    invoicecurrency: 'Invoice Currency',
    invoicedate: 'Invoice Date',
    format: ' ',
    receiveddate: 'Received Date',
    amortization: 'Amortization',
    pendingTasks: 'Pending Tasks',
    pendingTaskList: 'Pending Task List',
    approvalApi: 'Approval API',
    addNewParticipant: 'Add New Participant',
    'com.asyx.x4.pendingtask.reject.error': 'Failed when rejecting Pending Tasks.',
    hideMenu: 'Hide Menu',
    yourAccesUrl: 'Make sure the URL you access is',
    createInvoiceFreezeMsg:
        'Create document cannot be performed because the contract is currently freeze. Please contact your administrator for further assistance.',
    uploadInvoiceFreezeMsg:
        'Upload document cannot be performed because the contract is currently freeze for organization ',
    maturity_date_should_less_max_tenor:
        'Maturity Date should be less than Maximum Financing Tenor!',
    disponible_amount_exceed: 'Total Amount has exceeded the disponible amount!',
    net_plafond_exceed: 'Total Amount has exceeded the net plafond amount!',
    bifastErrorMsg:
        'Amount should be between 1 to 250.000.000 for BIFast payment method on Invoice ',
    llgErrorMsg: 'Amount should be between 1 to 1.000.000.000 for LLG payment method on Invoice ',
    rtgsErrorMsg: 'Amount should be above 1.000.000.000 for RTGS payment method on Invoice ',
    ben: 'BEN',
    our: 'OUR',
    counterpart: 'Counterpart',
    contract: 'Contract',
    select: 'Select...',
    'com.asyx.x4.notification.counterpart_not_allowed':
        'Counterpart feature cannot be used on this notification event',
    'com.asyx.x4.notification.should_general_contract': 'Selected contract should be general.',
    'com.asyx.x4.notification.contract_already_exist':
        'Notification template with same contract, event AND type already exist.',
    'com.asyx.x4.notification.template_already_exist':
        'Notification template with same event already exist.',
    invoicesCannotLessThanToday:
        'Invoices with a date earlier than today cannot be uploaded. Please ensure the invoice date is today or in the future',
    autoRetrySettlement: 'Auto Retry Settlement',
    retrySettlement: 'Retry Settlement',
    time: 'Time',
    accountBalance: 'Account Balance',
    specificResponse: 'Specific Response',
    'com.asyx.x4.notification.event_name_empty':
        'The Events field cannot be empty. Please select or enter the appropriate event.',
    'com.asyx.x4.notification.template_type_empty':
        'The Type field cannot be empty. Please select or enter the appropriate type.',
    'com.asyx.x4.notification.template_subject_empty':
        'The Subject field cannot be empty. Please select or enter the appropriate subject.',
    'com.asyx.x4.notification.template_content_empty':
        'The Content field cannot be empty. Please select or enter the appropriate content.',
    announcementManagement: 'Announcement',
    announcementDetail: 'Announcement Detail',
    title: 'Title',
    active: 'Active',
    intervalSpeed: 'Interval Speed',
    'com.asyx.x4.notification.cannot_delete_active_announcement':
        'Cannot delete active announcement.',
    'com.asyx.x4.notification.announcement_with_that_uuid_is_not_found':
        'Announcement with that uuid is not found.',
    'com.asyx.x4.notification.title_empty': 'Title is empty, Please input the appropriate title.',
    'com.asyx.x4.notification.description_empty':
        'Description is empty, Please input the appropriate description.',
    'com.asyx.x4.notification.interval_speed_empty':
        'Interval Speed is empty, Please input the appropriate interval speed.',
    'com.asyx.x4.notification.interval_speed_invalid':
        'Interval Speed is invalid, it should be between 1 and 25.',
    'com.asyx.x4.notification.active_announcement_already_exist':
        'Active announcement already exist, Only one active annoucement allowed.',
    'com.asyx.x4.notification.title_announcement_already_exist':
        'Announcement with same title is found, Please input with another title.',
    'com.asyx.x4.notification.asset_status_should_available':
        'Cannot delete invoice with asset status unavailable.',
    announcementCreated: 'Announcement has been created.',
    announcementUpdated: 'Announcement has been updated.',
    announcementDeleted: 'Announcement has been deleted.',
    searchByTitleOrDecription: 'Search by title or description.',
    deleteInvoice: 'Delete Invoice',
    'com.asyx.x4.finprocess.settlement.invalid-settlement-transfer-approval':
        'The selected Financing Statements should have same value of settlement transfer approval.',
    fileSizeInfo: 'File Size',
    maximumTotalAttachmentFiles: 'Maximum total attachment files should be 5.',
    maximumTotalAttachmentFilesSize: 'The following files exceed the maximum size of 20MB',
    combineRecourse: 'Combine Recourse',
    successUpload: 'Attachment uploaded successfully!',
    attachmentFailedFormat: `The following file name must not use < & > % $ ; : ( ) *`,
    attachmentMaximalSize: 'The following file exceeds the maximum size of 20MB',
    referenceShouldNotContainSpaces: 'Reference should not contain spaces',
    numberNotAllowedOnFees:
        'Fee with type number is not supported. Please make a selection in percentage/amount',
    LLG: 'LLG',
    SHARED_REVENUE: 'Shared Revenue',
    DISBURSEMENT_AMOUNT: 'Disbursement Amount',
    BANK_CHARGE: 'Bank Charge',
    TRANSACTION_FEE: 'Transaction Fee',
    TECHNOLOGY_FEE: 'Technology Fee',
    RTGS: 'RTGS',
    OTHERS_FEE: 'Others Fee',
    PRINCIPAL: 'Principal',
    COMMISSION_FEE: 'Commission Fee',
    OFFSETTING_FEE: 'Offsetting Fee',
    REFERENCE_AMOUNT: 'Reference Amount',
    RABATE: 'Rebate',
    PROCESSING_FEE: 'Processing Fee',
    PROVISION_FEE: 'Provision Fee',
    SPREAD: 'Spread',
    BROKER_FEE: 'Broker Fee',
    COLLECTION_FEE: 'Collection Fee',
    amortizationDetail: 'Amortization Detail',
    deleteInvoiceProcess: 'Delete Invoice Process of ',
    isAlreadyExist: 'is already exist! ',
    realTimeTransaction: 'Real-time Disbursement',
    realTimeConstraints: 'Real-time Constraints',
    end: 'End',
    idleTime: 'Idle Time (HH:MM:SS)',
    'com.asyx.x4.contract.approval_more_than_one': 'Approval cannot be more than 1.',
    matrixCreated: 'Approval Matrix has been created.',
    matrixUpdated: 'Approval Matrix has been updated.',
    'com.asyx.x4.invoices.exceeds_tenor':
        'Maturity Date should be less than Maximum Financing Tenor!',
    pleaseAdd: 'Please Add the',
    accountUnderSection: 'account under the Account section.',
    'com.asyx.x4.document.pranota.invoice_amount_greater_than_total_pranota_amount':
        'The invoice amount exceeds the total pranota amount.',
    'com.asyx.x4.document.pranota.already_used': 'This invoice reference is already in use.',
    invalidDueDate: 'Due Date cannot be less than Invoice Date.',
    'com.asyx.x4.invoices.invalid_due_date': 'Due Date cannot be less than Invoice Date.',
};
